import { Component } from '@verndale/core';
import { debounce } from '../helpers';

class ArticleMasthead extends Component {
  preferReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    .matches;

  constructor(el: HTMLElement) {
    super(el);

    this.init();
  }

  setupDefaults() {
    this.dom = {
      articlePdf: this.el.querySelector<HTMLElement>('.articlePdf')
    };
  }

  addListeners() {
      window.addEventListener('resize', debounce(this.init.bind(this), 100));
    }

  init() {

    const mediaQuery = window.matchMedia('(max-width: 480px)');

  
    if (mediaQuery.matches) {
      (this.dom.articlePdf as HTMLDivElement)?.remove();             
    } 
    
  }
}



export default ArticleMasthead;
